module.exports = __webpack_public_path__ + "assets/img/icon7.95a3a1bd.svg";